import { createHttpEndpoint } from '../../utils'

import type { GetAdminBackOfficeMerchantsAutocompleteResponse } from './admin-backoffice.types'

/**
 * Get the merchants matching the autocomplete query (at least 1 char(s), can
 * search by id -exact match- or by company name -partial match-)
 *
 * @see {@link https://devportal.backmarket.io/catalog/default/api/seller-merchants-api/definition#tag/Admin-backoffice/operation/get-bm-merchants-bo_admin-merchants-autocomplete}
 */
export const getAdminBackOfficeMerchantsAutocomplete =
  createHttpEndpoint<GetAdminBackOfficeMerchantsAutocompleteResponse>({
    method: 'GET',
    operationId: 'getMerchantsAutocomplete',
    path: '/bm/merchants/bo-admin/merchants/autocomplete',
  })
